import { put, call, takeLatest } from 'redux-saga/effects';
import client from '../client';
import * as ghostActions from '../reducers/ghost';

export function* loadGhostPages() {
  yield put(ghostActions.loadGuidePages());
  yield put(ghostActions.loadSdkPages());
}

export function* loadGuidePages() {
  try {
    const response = yield call(client, { url: 'docs/guides/structure' });
    yield put(ghostActions.loadGuidePagesSuccess(response));
  } catch (err) {
    yield put(ghostActions.loadGuidePagesFail(err));
  }
}
export function* loadSdkPages() {
  try {
    const response = yield call(client, { url: 'docs/sdk/structure' });
    yield call(client, { url: 'docs/sdk/structure' });
    yield put(ghostActions.loadSdkPagesSuccess(response));
  } catch (err) {
    yield put(ghostActions.loadSdkPagesFail(err));
  }
}

export function* loadGuideContent({ payload: { id, type } }) {
  try {
    const response = yield call(client, { url: `docs/guides/${type}/${id}` });
    const result = {
      ...response,
      content: response.content ? response.content : ''
    }
    yield put(ghostActions.loadGuideContentSuccess(result));
  } catch (err) {
    yield put(ghostActions.loadGuideContentFail(err));
  }
}

export function* loadSdkContent({ payload: { id, type } }) {
  try {
    const response = yield call(client, { url: `docs/guides/${type}/${id}` });
    const result = {
      ...response,
      content: response.content ? response.content : ''
    }
    yield put(ghostActions.loadSdkContentSuccess(result));
  } catch (err) {
    yield put(ghostActions.loadSdkContentFail(err));
  }
}

export default function* ghostSaga() {
  yield takeLatest(ghostActions.loadGhostPages, loadGhostPages);
  yield takeLatest(ghostActions.loadGuidePages, loadGuidePages);
  yield takeLatest(ghostActions.loadGuideContent, loadGuideContent);
  yield takeLatest(ghostActions.loadSdkPages, loadSdkPages);
  yield takeLatest(ghostActions.loadSdkContent, loadSdkContent);
}
